import {
  Box,
  Button as MuiButton,
  TableContainer,
  styled,
} from "@mui/material";
import { format } from "date-fns";
import React from "react";

import {
  CustomTable,
  EXPAND_DETAILS_COLUMN,
} from "components/CustomTable/CustomTable";
import { formatToNaira } from "utils/formatCurrency";

import { STATUS_TYPES } from "pages/Dashboard/components/DashboardChart/components/StatusFilter";
import { generateReceipt } from "utils/generateReceipt";
import { ReceiptIcon } from "components/Icons/ReceiptIcon";

const Button = styled(MuiButton)(() => ({
  textDecoration: "underline",
  marginTop: "25px",
  marginBottom: "25px",
  textTransform: "capitalize",
  color: "#0E60E2",
}));

const StatusStyle = styled(Box)(() => ({
  display: "inline-flex",
  justifyContent: "center",
  borderRadius: "20px",
  padding: "5px 15px",
}));

const StyledCustomTable = styled(CustomTable)(() => ({
  ".MuiTableRow-head .MuiTableCell-root": {
    borderBottom: "none",
    paddingLeft: "0px",
    paddingRight: "0px",
    color: "#7C7A78",
  },
  ".MuiTableRow-root": {
    background: "none",
    "&:hover": {
      background: "none",
    },
    ".MuiTableCell-root": {
      borderBottom: "none",
      paddingLeft: "0px",
    },
  },
}));

export const TransactionDetailsTable = ({ data, loading }) => {
  const amount = data?.reduce((acc, item) => acc + item.amount, 0) || 0;
  const totalAmount = formatToNaira(amount);

  const rows = data?.map((transactions) => ({
    id: transactions.transId,
    description: transactions.description,
    amount: formatToNaira(transactions.amount),
    date: format(new Date(transactions.createdOn * 1000), "dd/MM/yyyy hh:mm a"),
    status: transactions.status,
    reference: transactions.transIdRef,
    bank: transactions.bankName,
    mode: transactions.paymentMode,
    accountNo: transactions.accountNo,
    accountName: transactions.accountName,
    debitAccount: transactions.debitAccount,
    debitBankName: transactions.debitBankName,
    reason: transactions.reason,
  }));

  const columns = [
    { field: "description", headerName: "DESCRIPTION" },
    { field: "reference", headerName: "REFERENCE NUMBER" },
    {
      field: "amount",
      headerName: "AMOUNT",
    },
    {
      field: "date",
      headerName: "DATE & TIME",
      width: "150px",
    },
    {
      field: "status",
      headerName: "STATUS",
      width: "150px",
      renderCell: (row) => {
        if (row.status === STATUS_TYPES.SUCCESS) {
          return (
            <StatusStyle
              sx={{
                backgroundColor: "#E9F8F3",
                color: "#25B883",
              }}
            >
              Successful
            </StatusStyle>
          );
        } else if (row.status === STATUS_TYPES.FAILED) {
          return (
            <StatusStyle
              sx={{
                backgroundColor: "#FEEFF0",
                color: "#F25A68",
              }}
            >
              Failed
            </StatusStyle>
          );
        } else {
          return (
            <StatusStyle
              sx={{
                backgroundColor: "#FFE4CC",
                color: "#FF9900",
              }}
            >
              Pending
            </StatusStyle>
          );
        }
      },
    },
    {
      field: "reason",
      headerName: "REASON",
    },
    {
      ...EXPAND_DETAILS_COLUMN,
      width: "150px",
    },
  ];
  const detailsColumns = [
    {
      field: "bank",
      headerName: "BANK NAME",
    },
    {
      field: "mode",
      headerName: "PAYMENT MODE",
    },
    {
      field: "accountNo",
      headerName: "BANK ACCOUNT NO",
    },
    {
      field: "accountName",
      headerName: "ACCOUNT NAME",
    },
    {
      field: "debitBankName",
      headerName: "DEBIT BANK",
    },
    {
      field: "debitAccount",
      headerName: "DEBIT ACCOUNT",
    },
  ];

  return (
    <TableContainer sx={{ boxShadow: "none" }}>
      <CustomTable
        columns={columns}
        rows={rows}
        loading={loading}
        expandableRowComponent={({ row }) => {
          return (
            <Box>
              <StyledCustomTable
                columns={detailsColumns}
                rows={[row]}
                size="small"
              />
              <Box mt={2}>
                <Button
                  variant="text"
                  onClick={() =>
                    generateReceipt({
                      data: row,
                      totalAmount,
                      isCredit: row.amount > 0,
                    })
                  }
                >
                  <ReceiptIcon />
                  Generate Receipt
                </Button>
              </Box>
            </Box>
          );
        }}
      />
    </TableContainer>
  );
};
